import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    currency: 'DT',
    currency_symbol: 'DT',
    max_users: 10,
    items_per_page: 10,
    chart_period_months: 12,
  });
  const [loading, setLoading] = useState(false);

  const fetchSettings = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(`${API}/settings`);
      setSettings({
        currency: response.data.currency || 'DT',
        currency_symbol: response.data.currency_symbol || 'DT',
        max_users: response.data.max_users || 10,
        items_per_page: response.data.items_per_page || 10,
        chart_period_months: response.data.chart_period_months || 12,
      });
    } catch (error) {
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetchSettings();
    }
  }, [fetchSettings]);

  const updateSettings = useCallback((newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  }, []);

  const value = useMemo(() => ({
    settings, loading, fetchSettings, updateSettings
  }), [settings, loading, fetchSettings, updateSettings]);

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
